import React from "react";

export default function ExampleDob() {

  return (
    <>
      <div className="sub-title-bold">สำหรับผู้ที่ไม่ทราบวันหรือเดือนเกิด</div>

      <div>หน้าบัตรประชาชนแสดง '-' กรุณาแทนค่าด้วย 01</div>

      <div className="highlight">ตัวอย่าง 1</div>

      <div>หน้าบัตรประชาชน 'พ.ศ. 2520' ให้ระบุ 01/01/2520</div>

      <div className="highlight">ตัวอย่าง 2</div>

      <div>หน้าบัตรประชาชน 'ก.ย. 2520' ให้ระบุ 01/09/2520</div>
    </>
  );
}